import store from '@/store';
import config from '@/config';
import axios from 'axios';
// Set default Accept header for requests
axios.defaults.headers.common.Accept = 'application/json';

// sets base URL depending on configured env variables
// see config folder && webpack.conf.js
axios.defaults.baseURL = `${config.apiBaseUrl}/api`;

axios.interceptors.request.use(
  (reqConfig) => {
    if (reqConfig.headers.Authorization) {
      return reqConfig;
    }

    // eslint-disable-next-line no-param-reassign
    reqConfig.headers.Authorization = `Bearer ${store.getters.accessToken}`;
    return reqConfig;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      store.dispatch('logOut');
    }

    return response;
  },
  (error) => Promise.reject(error)
);
